function sortMaterialNames(materialNames) {
  return materialNames.slice().sort((a, b) => {
    const aStartsWithNumber = /^\d/.test(a)
    const bStartsWithNumber = /^\d/.test(b)

    if (aStartsWithNumber !== bStartsWithNumber) {
      return aStartsWithNumber ? -1 : 1
    }

    return a.localeCompare(b, undefined, { numeric: true })
  })
}

module.exports = {
  sortMaterialNames
}
